import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { BASE } from './models/Constants';

export default class TokensResources {

    constructor(private http: HTTPClient) { }

    public async hasSpid() {
        try {
            const res = await this.http.get(`${BASE}/saml/tags/spid/count`);
            return res.data > 0 ? true : false;
        } catch (error) {
            return false;
        }
    }
}
